import { ref, onUnmounted } from 'vue';

export function useTimeoutTimer(
  timeoutMs: number = 5 * 60 * 1000, // 5 minutes
  checkIntervalMs: number = 5 * 1000, // 5 seconds
) {
  const timeout = ref(false);
  const startTime = ref<number | null>(null);

  let timer: ReturnType<typeof setInterval> | null = null;

  const clear = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const start = (callback: () => void) => {
    startTime.value = Date.now();
    timeout.value = false;

    if (timer) clearInterval(timer);

    timer = setInterval(() => {
      if (!startTime.value) return;

      const elapsed = Date.now() - startTime.value;

      if (elapsed >= timeoutMs) {
        timeout.value = true;
        clear();
        callback();
      }
    }, checkIntervalMs);
  };

  const refresh = () => {
    startTime.value = Date.now();
    timeout.value = false;
  };

  onUnmounted(clear);

  return {
    timeout,
    startTime,
    start,
    refresh,
    clear,
  };
}
